import React from 'react';
import { Box, Typography } from '@mui/material';
import { ChatBubbleOutline } from '@mui/icons-material';

export const ChatEmptyState: React.FC = () => (
  <Box 
    display="flex" 
    flexDirection="column" 
    alignItems="center" 
    justifyContent="center" 
    height="100%" 
    p={3}
    sx={{ backgroundColor: '#f5f7fa' }}
  >
    <Box sx={{ 
      p: 4, 
      borderRadius: '50%', 
      backgroundColor: 'white', 
      mb: 2,
      boxShadow: '0 4px 20px rgba(0,0,0,0.05)'
    }}>
      <ChatBubbleOutline sx={{ fontSize: 60, color: 'text.secondary' }} />
    </Box>
    <Typography variant="h6" color="text.primary" gutterBottom>
      Оберіть чат
    </Typography>
    <Typography variant="body2" color="text.secondary" align="center" maxWidth={300}>
      Виберіть співрозмовника зі списку ліворуч або створіть нову розмову, щоб почати спілкування.
    </Typography>
  </Box>
);
